import { FontColorEnum } from '@acceso/design-system';

import { ListboxProvider } from './ListboxContext';
import ListboxMultiple from './ListboxMultiple';
import ListboxSimple from './ListboxSimple';
import { ListboxProps } from './ListboxTypes';

function Listbox<T>({
  mode,
  parentCanBeChecked,
  onChange,
  selected,
  color = FontColorEnum.Default,
  onClose,
  ...props
}: ListboxProps<T>) {
  return (
    <ListboxProvider
      mode={mode}
      parentCanBeChecked={parentCanBeChecked}
      onChange={onChange}
      selected={selected}
      onClose={onClose}
    >
      {(mode === 'simple' || mode === 'single') && <ListboxSimple color={color} {...props} />}
      {mode === 'multiple' && <ListboxMultiple color={color} {...props} />}
    </ListboxProvider>
  );
}

export default Listbox;
